import { Injectable } from '@angular/core';
import { Broker } from '@c4/core';

@Injectable()
export class EnvironemntService {

  constructor(private broker: Broker) {}

  // get enable/disable status of processes
  public getEnvironment = (): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

      let request: any = {
          method: 'GET',
          path: '/api/v1/environment'
      };
      this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  //  enable/disable process
  public setEnvironment = (env : string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {

        var sendPost: any = {};
        sendPost["environment"] = env;
        var request: any = {
          method: 'PUT',
          path: '/api/v1/environment',
          data: sendPost
        };
        this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/env.service.ts